import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { DunningNoticesPage } from "@/features/dunning-ops";

export const Route = createFileRoute("/dunning-notices/")({
  component: DunningNoticesRoute,
});

function DunningNoticesRoute() {
  return (
    <AdminDashboardShell>
      <DunningNoticesPage />
    </AdminDashboardShell>
  );
}
